import { logEvent, setUserId } from 'firebase/analytics';
import { getAnalyticsInstance } from '../firebase/config';

export const track = async (eventName, params = {}) => {
  const analytics = await getAnalyticsInstance();
  if (!analytics) return;
  logEvent(analytics, eventName, params);
};

export const identify = async (userId) => {
  const analytics = await getAnalyticsInstance();
  if (!analytics) return;
  setUserId(analytics, userId);
};
